export default __webpack_public_path__ + "static/media/JE.ad293465.svg";